import { Title } from 'shared/index.js';
import UserSettingsForm from '../UserSettingsForm/UserSettingsForm.jsx';

// import css from './UserSettingsModal.module.css';

const UserSettingsModal = () => {
  return (
    <>
      <Title>Setting</Title>
      <UserSettingsForm />
    </>
  );
};

export default UserSettingsModal;
